import * as React from "react";
import { Theme, makeStyles, createStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: 64,
      paddingBottom: 50,
      paddingLeft: 0,
      paddingRight: 0,
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%",
    },
  })
);

export const SubscriptionsLayout: React.FC = (props) => {
  const classes = useStyles();
  return <div className={classes.root}>{props.children}</div>;
};
